<template>
  <section>
    <!-- SB-43 -->
    <banner-full-width headerText="Équipement"></banner-full-width>
    <div
      id="sb-43"
      v-if="$store.state.currentLocation >= 43"
    >
      <content-block>
        <!-- 5-01-00 -->
        <!-- <banner-full-width headerText=""></banner-full-width> -->
        <!-- <h1 class="animated infinite bounce delay-2s">Example</h1> -->
        <h2 class="content-block__header content-block__header--red">À venir</h2>
        <p>Dans cette section, nous déterminerons l'équipement de sécurité qui doit se trouver dans une embarcation d'aviron, une embarcation d'entraîneur et au hangar et ce que vous devez faire pour veiller à l'utilisation sécuritaire de l'équipement.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="44"
          link="sb-44"
        >
          Dites-m’en plus
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-44 -->
    <div
      id="sb-44"
      v-if="$store.state.currentLocation >= 44"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Vérifier l'embarcation d'aviron</h2>
        <p>En aviron, la vérification de tous les articles que vous utilisez sur l'eau fait partie des bonnes pratiques, alors commençons par l'embarcation. Placez le bateau sur des chevalets pour une vérification approfondie avant de l'apporter au quai.</p>
        <ul class="chevron-list">
          <li>Vérifiez que la quincaillerie des portants est bien fixée et qu'il ne manque aucune pièce. Idéalement, vérifiez le serrement avec une clé.</li>
          <li>Vérifiez que les dames de nage sont en bon état, c'est-à-dire qu'elles ne sont pas fissurées et qu'il n'y a pas de signe d'usure importante.</li>
          <li>Assurez-vous que l'écrou du dessus de la dame de nage est bien serré.</li>
          <li>Passez votre main sur la coque pour vérifier qu'il n'y a pas de fissure ni à l'intérieur, ni à l'extérieur, ni sur la plateforme.</li>
          <li>Si du ruban adhésif recouvre une fissure ou une encoche (souvent utilisé comme solution rapide), assurez-vous qu'il est bien fixé et que les bords ne se soulèvent pas.</li>
          <li>Vérifiez que les couverts sont bien installés et qu'ils ne sont pas montés les uns sur les autres, ce qui permettrait à l'eau de s'infiltrer dans le compartiment étanche.</li>
          <li>Placez les rondelles si vous connaissez la hauteur de la dame de nage qu'il vous faut (ces rondelles déterminent la hauteur de la rame). </li>
        </ul>
        <p>Il est à noter que la hauteur des rondelles peut être différente d'une personne à l'autre. Il est plus facile de les ajuster à l'extérieur de l'eau, pendant que vous vérifiez votre embarcation, mais vous pouvez aussi les ajuster sur l'eau, au besoin. </p>
        <p>Si la quincaillerie des portants doit être remplacée et que vous êtes à même de le faire, faites-le. Il y a souvent un bac avec des vis, des écrous et des clés au hangar à bateau pour faciliter les ajustements avant d'aller sur l'eau.</p>
      </content-block>
      <content-block class="bg-img bg-img--01">
        <h3 class="text-red">L'équipement de sécurité dans l'embarcation</h3>
        <p>Toutes les embarcations, y compris les embarcations d'aviron, doivent respecter les exigences de Transports Canada.  </p>
        <p>Une embarcation d'aviron doit avoir des feux de navigation, y compris un feu à la proue, préférablement rouge et vert, et un feu blanc à la poupe, notamment en cas de sortie une heure avant le lever du soleil et une heure après le coucher du soleil. </p>
        <p>Il doit y avoir un VFI pour chaque rameur dans l'embarcation, un dispositif d'avertissement sonore (comme un sifflet) et une lumière étanche, à moins d'être accompagné par une embarcation d'entraîneur.</p>
        <p>En tant que rameur, vous êtes responsable d'apprendre les exigences de Transports Canada. Il est conseillé de les revoir au début de chaque saison, en guise de rappel.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="45"
          link="sb-45"
        >
          J'y veillerai
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-45 -->
    <div
      id="sb-45"
      v-if="$store.state.currentLocation >= 45"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Vérifier les cale-pieds  </h2>
        <div class="row">
          <div class="col-md-4 text-red">
            <p>Les cale-pieds sont un élément de sécurité important. C'est grâce à eux que le rameur est bien ancré à l'embarcation, mais ils lui permettent aussi de sortir ses pieds facilement si l'embarcation chavire.</p>
            <p>Lorsque vous vérifiez les cale-pieds{{'\xa0'}}:</p>
          </div>
          <div class="col-md-4 col-sm-6">
            <ul class="grid-list">
              <li>Assurez-vous que la quincaillerie des cale-pieds (les écrous et les boulons) est bien serrée.</li>
              <li>Ajustez les cale-pieds selon vos besoins.</li>
            </ul>
          </div>
          <div class="col-md-4 col-sm-6">
            <ul class="grid-list grid-list--border-left">
              <li>Vérifiez que les talons sont attachés et qu'ils ne se soulèvent pas à plus de 7 cm (3 à 4 doigts) du bas des cale-pieds.</li>
              <li>Vérifiez que les pieds peuvent être dégagés d'un seul mouvement rapide de la main en tirant sur une courroie facilement accessible.</li>
            </ul>
          </div>
        </div>
        <p class="pt-3">Lorsque vous devez remplacer les cale-pieds, remplacez-les et fixez-les vous-même seulement si vous êtes certain de pouvoir le faire correctement.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="46"
          link="sb-46"
        >
          Je vérifierai les cale-pieds
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-46 -->
    <div
      id="sb-46"
      v-if="$store.state.currentLocation >= 46"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Vérifier le siège </h2>
        <p>Votre siège devrait être confortable et fonctionnel.  </p>
        <p>Pour vérifier le siège{{'\xa0'}}:</p>
        <ul class="chevron-list">
          <li>Assurez-vous qu'il glisse facilement et doucement.  </li>
          <li>Ajustez la coulisse, au besoin.</li>
          <li>Assurez-vous que les rails du siège sont au même niveau pour éviter de heurter l'avant ou l'arrière des rails lorsque vous ramez.</li>
          <li>Vérifiez que les écrous des rails sont assez serrés. Vous pouvez le faire sur l'eau, mais c'est plus facile à faire lorsque l'embarcation est sur des chevalets.</li>
        </ul>
        <p>Si vous savez comment remplacer et fixer solidement les pièces de votre siège, faites-le avant de sortir sur l'eau.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="47"
          link="sb-47"
        >
          Je vérifierai le siège
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-47 -->
    <div
      id="sb-47"
      v-if="$store.state.currentLocation >= 47"
    >
      <content-block class="bg-img bg-img--02">
        <h2 class="content-block__header content-block__header--red">Vérifier la dérive et la balle de proue </h2>
        <p>La dérive et la balle de proue sont fixées à votre embarcation. La dérive permet d'avancer en ligne droite et elle contribue aussi à l'équilibre. </p>
        <p>La balle de proue diminue le risque de défoncer quelque chose ou de blesser quelqu'un et prévient les dommages à la coque.  </p>
        <p>Lorsque vous vérifiez votre embarcation, assurez-vous que{{'\xa0'}}:</p>
        <div class="row">
          <div class="col-sm bg-red text-center p-4 m-3">
            <p>La dérive est solidement fixée et alignée avec la coque.</p>
          </div>
          <div class="col-sm bg-red text-center p-4 m-3">
            <p>La balle de proue est solidement fixée et elle n'est pas fissurée ou endommagée.</p>
          </div>
          <div class="col-sm bg-red text-center p-4 m-3">
            <p>Les compartiments à la proue et à la proue de l'embarcation sont bien fermés et étanches.</p>
          </div>
        </div>
        <button-sequenced
          class="btn-nav--red"
          :loc="48"
          link="sb-48"
        >
          Je vérifierai la dérive et la balle de proue
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-48 -->
    <div
      id="sb-48"
      v-if="$store.state.currentLocation >= 48"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Vérifier les rames  </h2>
        <div class="row">
          <div class="col-md-4 text-red">
            <p>Vérifiez toujours les rames d'aviron de couple ou de pointe avant de sortir sur l'eau. Elles ne font pas partie de l'embarcation, mais elles font partie de la pratique d'aviron. </p>
          </div>
          <div class="col-md-4 col-sm-6">
            <ul class="grid-list">
              <li>Vérifiez qu'il n'y a pas de fissures ou de marques sur les pelles et les manches.</li>
              <li>Vérifiez les poignées pour vous assurer qu'elles sont propres et non usées. </li>
            </ul>
          </div>
          <div class="col-md-4 col-sm-6">
            <ul class="grid-list grid-list--border-left">
              <li>Vérifiez que le col de la rame est bien fixé.</li>
              <li>Vérifiez que les vis et les boulons sont bien serrés si la rame n'est pas ajustable. </li>
            </ul>
          </div>
        </div>
        <button-sequenced
          class="btn-nav--red"
          :loc="49"
          link="sb-49"
        >
          Je vérifierai les rames
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-49 -->
    <div
      id="sb-49"
      v-if="$store.state.currentLocation >= 49"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Vérifier l'équipement de sécurité de l'embarcation d'entraîneur ou de sécurité  </h2>
        <p>En tout temps, l'embarcation d'entraîneur ou de sécurité doit avoir{{'\xa0'}}:</p>
        <ul class="chevron-list">
          <li>Un VFI approuvé pour chaque occupant du bateau d'entraîneur et pour chaque membre du plus grand équipage supervisé</li>
          <li>Une ligne d'attrape flottante</li>
          <li>Une rame</li>
          <li>Un signal d'avertissement sonore</li>
          <li>Une écope</li>
          <li>Une lumière étanche ou des fusées éclairantes</li>
          <li>Des feux de navigation en cas de sortie avant le lever du soleil et après le coucher du soleil</li>
          <li>Des couvertures thermiques</li>
        </ul>
        <p>Transports Canada détaille cette liste dans son <em>Guide de sécurité nautique</em> publié en ligne et que vous trouverez sur le site web de RCA.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="50"
          link="sb-50"
        >
          Je consulterai le Guide
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-50 -->
    <div
      id="sb-50"
      class="bg-img bg-img--04"
      v-if="$store.state.currentLocation >= 50"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Vérifier les ressources de sécurité du hangar</h2>
        <p>Nous recommandons aux clubs de respecter les mesures de sécurité suivantes{{'\xa0'}}:</p>
        <ul class="chevron-list">
          <li>Communiquez l'endroit où trouver le plan d'action d'urgence et assurez-vous que les membres le lisent afin de savoir quoi faire en cas d'urgence.</li>
          <li>Communiquez l'endroit où trouver la trousse de premiers soins et veillez à ce qu'elle soit bien remplie en tout temps. L'adresse du club doit être bien visible pour que les répartiteurs du 911 aient les bons renseignements.</li>
          <li>Si vous en avez un, veillez à ce que le défibrillateur externe automatique (DEA) soit bien en vue et que plusieurs membres connaissent le mode de fonctionnement.</li>
          <li>Si vous en avez une, placez la bouée de sauvetage bien en vue sur le quai au cas où vous en auriez besoin.</li>
          <li>Gardez une quantité suffisante de couvertures thermiques et de laine et assurez-vous que les membres connaissent l'endroit où elles sont rangées.</li>
          <li>Mettez à la disposition des membres un carnet de réparation afin que les membres puissent y indiquer l'équipement nécessitant réparation (pour éviter que l'équipement brisé soit réutilisé et pour que le matériel soit réparé rapidement).</li>
          <li>Pensez à utiliser un journal de sortie et d'entrée à remplir avant de sortir sur l'eau et au retour.</li>
        </ul>
        <button-sequenced
          class="btn-nav--red"
          :loc="51"
          link="sb-51"
        >
          C'est logique
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-51 -->
    <div
      id="sb-51"
      v-if="$store.state.currentLocation >= 51"
    >
      <content-block class="quiz-bg">
        <h2 class="content-block__header ">Vous avez tout ce qu'il faut?</h2>
        <quiz-radio
          :questions="q01"
          @quiz-complete="
                $store.dispatch('showNext', { n: 52, el: '#menu' })
              "
        ></quiz-radio>
      </content-block>
    </div>

    <footer
      class="course-menu"
      id="menu"
      v-if="$store.state.currentLocation >= 52"
    >
      <h3>Menu principal</h3>
      <cac-menu :menuItems="$store.state.menuItems"></cac-menu>
    </footer>
  </section>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import CacHeader from '@/components/cac-components/CacHeader.vue';
import CacMenu from '@/components/cac-components/CacMenu.vue';
import BannerFullWidth from '@/components/BannerFullWidth.vue';
import ContentBlock from '@/components/ContentBlock.vue';
import ButtonSequenced from '@/components/ButtonSequenced.vue';
import AccordionIcon from '@/components/AccordionIcon.vue';
import Accordion from '@/components/Accordion.vue';

// Quiz stuff
import QuizRadio from '@/components/QuizRadio.vue';
import QuizCheckbox from '@/components/QuizCheckbox.vue';

export default {
  name: 'nccp',
  components: {
    CacHeader,
    CacMenu,
    BannerFullWidth,
    ContentBlock,
    ButtonSequenced,
    AccordionIcon,
    Accordion,
    QuizRadio
  },
  data() {
    return {
      showModal: false,
      // 3-01-03
      q01: [
        // Q1
        {
          id: 0,
          questionText: `
            <p class="text-key-take">C'est la fin de l'automne et vous vous préparez à une séance d'entraînement tôt le matin avec votre équipage. Vous vous apprêtez à sortir sans la supervision directe d'un entraîneur.  </p>
            <p class="text-key-take">Que <strong>devez-vous</strong> avoir comme équipement dans votre embarcation? </p>
          `,
          questionArray: [
            'Des VFI, des bouteilles d\'eau, une clé à ouverture fixe, des vêtements chauds',
            'Des VFI, une écope, des bouteilles d\'eau et des feux de navigation',
            'Des VFI, un sifflet, des lumières étanches',
            'Une rame, une écope, un câble de remorque et des couvertures thermiques'
          ],
          corrective: 'Des VFI, un sifflet, des lumières étanches',
          model: [],
          answer: '',
          answerText: `
            <p>Il est recommandé d'avoir des bouteilles d'eau, des clés à ouverture et des vêtements chauds, mais ce n'est pas obligatoire dans une embarcation d'aviron. Les VFI, un dispositif d'avertissement sonore et des feux de navigation ou des lumières étanches font partie des exigences de Transports Canada.</p>
          `,
        },
      ],
    };
  },
  methods: {
    tabContent(index) {
      this.tabIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
/*------------------------------------*\
    #PRIMARY COLOURS
  \*------------------------------------*/

/*------------------------------------*\
    #Mixins
  \*------------------------------------*/

/*------------------------------------
    #MEDIA SCREENS < 768px (#MOBILE FIRST)
  \*------------------------------------*/
.banner {
  // background-image: url('../assets/img/_chapter-headers/mbl/01-welcome-mbl.png');
  background-image: url("../assets/img/_chapter-headers/mbl/7-equipment-mbl-fr.jpg");
  color: #000;
  background-position: center;
  padding: 60% 10%;
  &__header {
    color: #000;
  }
}

/*------------------------------------*\
    #MEDIA SCREENS > 576px (TABLETS)
  \*------------------------------------*/
@media (min-width: 576px) {
  .banner {
    // background-image: url('../assets/img/_chapter-headers/dsk/01-welcome-dsk.png');
    background-image: url("../assets/img/_chapter-headers/dsk/7-equipment-dsk-fr.jpg");
    color: #000;
    padding: 10% 10% 14%;
    background-position: center;
    &__header {
      color: #000;
    }
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
  // .banner {
  //   background-image: url('../assets/img/_bg/1-01-01-bg-dsk.png');
  //   color: #fff;
  //   padding: 10% 10%;
  //   background-position: center;
  //   &__header {
  //       color: #fff;
  //   }
  // }
}

/*------------------------------------*\
    #MEDIA SCREENS > 992px
    (LAPTOP, TABLET)
  \*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1200px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1320px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1600px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
